import { useAdminModeContext } from '@/context/adminModeContext';
import { GlobalSearch } from '@/components/GlobalSearch';
import { CrmSideNavBrand, CrmSideNavBrandCaption } from './SideNavBar/crm/CrmSideNavBrand';
import { CrmSideNavSections } from './SideNavBar/crm/CrmSideNavSections';
import { AdminSideNavBrand } from './SideNavBar/admin/AdminSideNavBrand';
import { AdminSideNavSections } from './SideNavBar/admin/AdminSideNavSections';
import { CrmTopNavActions } from './TopNavigationMenu/crm/CrmTopNavActions';
import { CrmAccountAvatar, CrmAccountLabel } from './TopNavigationMenu/crm/CrmAccountIdentity';
import { CrmProfileMenuItem } from './TopNavigationMenu/crm/CrmProfileMenuItem';
import { MobileMenu } from './TopNavigationMenu/MobileMenu';
import {
	AdminAccountAvatar,
	AdminAccountLabel,
} from './TopNavigationMenu/admin/AdminAccountIdentity';

/**
 * The content the side nav and top nav shells render for each mode. A null entry
 * renders nothing in that slot.
 */
const navVariants = {
	crm: {
		Brand: CrmSideNavBrand,
		BrandCaption: CrmSideNavBrandCaption,
		Sections: CrmSideNavSections,
		Search: GlobalSearch,
		Actions: CrmTopNavActions,
		MobileActions: MobileMenu,
		AccountAvatar: CrmAccountAvatar,
		AccountLabel: CrmAccountLabel,
		ProfileMenuItem: CrmProfileMenuItem,
	},
	admin: {
		Brand: AdminSideNavBrand,
		BrandCaption: null,
		Sections: AdminSideNavSections,
		Search: null,
		Actions: null,
		MobileActions: null,
		AccountAvatar: AdminAccountAvatar,
		AccountLabel: AdminAccountLabel,
		ProfileMenuItem: null,
	},
};

export const useNavVariant = () => {
	const { isAdminMode } = useAdminModeContext();
	return navVariants[isAdminMode ? 'admin' : 'crm'];
};
